import { useSelector } from 'react-redux'
import { Home, User } from '@lmc/ts-common'
import { mixpanel } from 'common/services/analytics'
import { Dict } from 'mixpanel-browser'
import { useCallback } from 'react'

export enum MixpanelEvents {
  PAGE_VISITED = 'Page visited',
  ROSTERING_REPORT_DOWNLOADED = 'Rostering_Report_Downloaded',
  ROTA_BASED_ACCESS_CHANGED = 'Rota_Based_Access_Changed',
  ROTA_BUILDER_TAB_VIEWED = 'Rota_Builder_Tab_Viewed',
  START_ROTA_GENERATED = 'Start_Rota_Generated',
  ROTA_FILTERS_APPLIED = 'Rota_Filters_Applied',
  ROTA_PATTERN_EDIT_UPDATE_EVENTS = 'Rota_Pattern_Edit_Update_Events',
}

export const sendMixpanelEvent = (
  event: MixpanelEvents,
  props: Dict,
  home: Home,
  user: User,
) => {
  const homeGroup = home?.homeGroup ?? 'No home group'
  const homeId = home?.id ?? 'Unknown Home'

  mixpanel.track(event, {
    group: homeGroup,
    homeName: home?.name || 'Unknown Home',
    home: homeId,
    userId: user?.id || 'Unknown User',
    userName: user?.name
      ? `${user.name.first} ${user.name.last}`
      : 'Unknown User',
    ...props,
  })
}

const useMixpanelEvent = () => {
  const home = useSelector(
    (state: { global: { home: Home } }) => state.global.home,
  )
  const user = useSelector(
    (state: { global: { user: User } }) => state.global.user,
  )

  const sendEvent = useCallback(
    (event: MixpanelEvents, props: Dict) => {
      sendMixpanelEvent(event, props, home, user)
    },
    [home, user],
  )

  return sendEvent
}

export default useMixpanelEvent
